import { createGlobalStyle } from 'styled-components'
import cssVariables from './cssVariables'

export const GlobalStyling = createGlobalStyle`
	* {
		box-sizing: border-box;
	}

  html, body {
    font-family: 'gotham', Arial, Tahoma, Verdana, Helvetica, sans-serif;
    font-size: 13px;
    color: ${cssVariables.colors.text.primary} ;
    background: ${cssVariables.colors.background.primary};
  }

  select:not(:disabled),
  button:not(:disabled) {
    cursor: pointer;
  }

  input, select, textarea, button {
    font-family: inherit;
    letter-spacing: inherit;
  }

  html {
    font-size: 100%;
    text-size-adjust: 100%;
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  img {
    max-width: 100%;
  }

  .Button .Spinner-anim {
    width: 25px;
    height: 25px;
  }

  .Button--default.Button--danger {
    border-color: #c12a18;
    background: #c12a18;
  }

  		/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type=number] {
		-moz-appearance:textfield;
	}
`
